import { useNotification } from "hooks/useNotification";
import { useMutation } from "@tanstack/react-query";
import instance from "./axiosInstance";

export const useUploadFiles = () => {
  const notification = useNotification();

  return useMutation({
    mutationFn: async (payload: File[]): Promise<string[]> => {
      const formData = new FormData();
      // console.log({ payload });
      payload.forEach((file) => formData.append("files", file));
      // console.log({ formData });
      return (
        await instance.post("/image/upload-many", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
      ).data;
    },
    onError: () => {
      notification.error("Något gick fel, kontakta support");
    },
  });
};

export const useUploadLogos = () => {
  const notification = useNotification();

  return useMutation({
    mutationFn: async (payload: File[]): Promise<string[]> => {
      const formData = new FormData();
      payload.forEach((file) => formData.append("files", file));
      return (
        await instance.post("/image/upload-logo", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
      ).data;
    },
    onError: () => {
      notification.error("Något gick fel, kontakta support");
    },
  });
};
